import { render, staticRenderFns } from "./MoleculeChartColumns.vue?vue&type=template&id=64665b92"
import script from "./MoleculeChartColumns.vue?vue&type=script&lang=js"
export * from "./MoleculeChartColumns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports